import type { ApiConfig } from "@/data/types/api-config";
import { storageManager } from "@/services/storage/storage/storage";

const DEFAULT_SCOPE = "https://auth.trackman.com/dr/facility";

class ApiConfigStorage {
  private async ensureInitialized(): Promise<void> {
    await storageManager.initialize();
  }

  async setConfig(config: ApiConfig): Promise<void> {
    try {
      await this.ensureInitialized();
      const configWithDefaults: ApiConfig = {
        ...config,
        scope: config.scope || DEFAULT_SCOPE,
      };
      await storageManager.setApiConfig(configWithDefaults);
    } catch (error) {
      console.error("Failed to store API config:", error);
      throw error;
    }
  }

  async getConfig(): Promise<ApiConfig | null> {
    try {
      await this.ensureInitialized();
      return await storageManager.getApiConfig();
    } catch (error) {
      console.error("Failed to retrieve API config:", error);
      return null;
    }
  }

  async clearConfig(): Promise<void> {
    try {
      await this.ensureInitialized();
      await storageManager.clearApiConfig();
    } catch (error) {
      console.error("Failed to clear API config:", error);
    }
  }

  async hasConfig(): Promise<boolean> {
    const config = await this.getConfig();
    return config !== null;
  }
}

export const apiConfigStorage = new ApiConfigStorage();
